import React, { useContext } from 'react'
import { UserContext } from '../../wrappers/UserContext'

const LogoutButton = () => {
    const { client } = useContext(UserContext)
    return (
        <div className="button is-primary is-small" onClick={function() {client.logout()}}>
            Logout
        </div>
    )
}

export default LogoutButton